// src/components/MemberBarcodePanel.js
import React, { useRef } from 'react';
import Barcode from 'react-barcode';

function downloadSvgAsPng(svgEl, filename) {
  if (!svgEl) return;
  const svgData = new XMLSerializer().serializeToString(svgEl);
  const url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgData)}`;
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth || img.width;
    canvas.height = img.naturalHeight || img.height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0);
    const link = document.createElement('a');
    link.download = filename;
    link.href = canvas.toDataURL('image/png');
    link.click();
  };
  img.src = url;
}

function BarcodeBlock({ title, value, filenamePrefix }) {
  const wrapRef = useRef(null);
  if (!value) return null;

  const handleDownload = () => {
    const svg = wrapRef.current?.querySelector('svg');
    const safeName = String(filenamePrefix || 'barcode').replace(/[^\w\u4e00-\u9fff-]+/g, '_');
    downloadSvgAsPng(svg, `${safeName}.png`);
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{
        fontSize: 18,
        fontWeight: 800,
        color: '#5e3a1a',
        marginBottom: 10,
        letterSpacing: 2,
      }}>
        {title}
      </div>
      <div style={{
        background: 'rgba(255,255,255,.9)',
        borderRadius: 10,
        padding: '12px',
        border: '1px solid #e8dccb',
      }}>
        <div ref={wrapRef} style={{ overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
          <Barcode
            value={String(value)}
            displayValue={false}
            margin={0}
            width={2}
            height={60}
          />
        </div>
        <div style={{
          marginTop: 8,
          fontSize: 18,
          fontWeight: 700,
          color: '#5e3a1a',
          textAlign: 'center',
          letterSpacing: 2,
          fontFeatureSettings: '"tnum"',
        }}>
          {value}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          <button type="button" className="btn btn-info btn-sm" onClick={handleDownload}>
            下載圖片
          </button>
        </div>
      </div>
    </div>
  );
}

export default function MemberBarcodePanel({ member }) {
  if (!member) return null;

  const phone = String(member.PHONE || '').trim();
  const carrier = String(member.CARRIER || '').trim();

  if (!phone && !carrier) {
    return (
      <div style={{
        marginTop: 12,
        padding: 12,
        borderRadius: 10,
        background: '#faf6f0',
        border: '1px solid #e8dccb',
        color: '#8b7355',
        fontSize: 16,
      }}>
        尚無條碼資料（需有電話或載具）
      </div>
    );
  }

  return (
    <div style={{
      marginTop: 12,
      padding: 14,
      borderRadius: 10,
      background: '#f0dfd4',
      border: '1px solid #c28b4e',
    }}>
      <div style={{
        fontSize: 20,
        fontWeight: 900,
        color: '#5e3a1a',
        marginBottom: 12,
        letterSpacing: 2,
      }}>
        會員條碼
      </div>
      <BarcodeBlock title="載具" value={carrier} filenamePrefix={`carrier_${member.ID || 'member'}`} />
      {carrier && phone ? (
        <div style={{
          borderTop: '2px dashed #c28b4e',
          margin: '4px 0 16px',
          opacity: 0.5,
        }} />
      ) : null}
      <BarcodeBlock title="會員條碼" value={phone} filenamePrefix={`member_${member.ID || 'barcode'}`} />
    </div>
  );
}
